import React, { useState } from 'react';
import { Modal } from 'react-bootstrap-v5';
import { KTSVG, SimpleAlert } from '../../../../../rbts/helpers';
import { eliminarTipoPuntoVentaService } from '../../../../service/catalogos/TipoPuntoVenta';

type Props = {
  show: boolean;
  id_row: number;
  handleClose: (updateGrid: boolean) => void;
};

const RemoveModal: React.FC<Props> = ({ show, id_row, handleClose }) => {
  const [loading, setLoading] = useState(false);

  const handleDelete = async () => {
    setLoading(true);
    try {
      await eliminarTipoPuntoVentaService(id_row);
      SimpleAlert('Tipo eliminado exitosamente.', 3000, 'success');
      handleClose(true);
    } catch (error: any) {
      const message = error?.response?.data?.message ?? 'Ocurrió un error al eliminar.';
      SimpleAlert(message, 3000, 'error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      id="kt_modal_remove_tipo"
      tabIndex={-1}
      aria-hidden="true"
      dialogClassName="modal-dialog modal-dialog-centered mw-400px"
      show={show}
      onHide={() => handleClose(false)}
    >
      <div className="modal-content">
        <div className="modal-header">
          <h2>Eliminar tipo</h2>
          <div className="btn btn-sm btn-icon btn-active-color-primary" onClick={() => handleClose(false)}>
            <KTSVG className="svg-icon-2" path="/media/icons/duotune/arrows/arr061.svg" />
          </div>
        </div>
        <div className="modal-body text-center py-10">
          <p className="fs-5">¿Está seguro de que desea eliminar este tipo de punto de venta?</p>
          <p className="text-muted fs-7">Esta acción no se puede deshacer.</p>
        </div>
        <div className="modal-footer d-flex justify-content-center">
          <button type="button" className="btn btn-light me-3" onClick={() => handleClose(false)}>
            Cancelar
          </button>
          <button type="button" className="btn btn-danger" onClick={handleDelete} disabled={loading}>
            {!loading ? (
              'Eliminar'
            ) : (
              <span style={{ display: 'block' }}>
                Eliminando...
                <span className="spinner-border spinner-border-sm align-middle ms-2" />
              </span>
            )}
          </button>
        </div>
      </div>
    </Modal>
  );
};

export { RemoveModal };
